import { render, staticRenderFns } from "./ErrorWithCustomMessage.vue?vue&type=template&id=aa8cb7a8"
import script from "./ErrorWithCustomMessage.vue?vue&type=script&lang=js"
export * from "./ErrorWithCustomMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports